import request from "@utils/request";

const SearchApiService = {
    /**
     * 查询
     * @param sApi 查询接口
     * @param pageSize 展示行数
     * @param pageIndex 当前搜索页
     * @param fetchCondition  当时搜索字段值Map

     * @param callback
     * @returns {Function}
     */
    fetch(sApi, pageSize=10,pageIndex=1,data={}) {
        const pagingQuery = {
            pageIndex: pageIndex,
            pageSize: pageSize ,
        }
        data['pagingQuery'] = pagingQuery;
        return request({
            url:  sApi,
            method: "POST",
            data
        });
    }
};

export default SearchApiService;
